module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": "Contacts",
      "titleHeading": "h3",
      "titleClass": "text-info",
      "table-ref": "contacts-table",
      "url": '/contacts/org' + (this.org_id ? '/' + Number(this.org_id) : ''),
      "fields": _vm.fields,
      "org-badge": _vm.orgBadge,
      "sort-field": "name",
      "add-action": _vm.action,
      "add-props": _vm.addProps,
      "detail-component": "contact-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-875db6cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/ContactsTable.vue
// module id = 1671
// module chunks = 0